const queryKeys = {
  getIAMRoles: 'getIAMRoles',
  supervisorProfile: 'supervisorProfile',
  arePerformance: 'arePerformance',
  areDetail: 'areDetail',
  areTarget: 'areTarget',
  supervisorPerformance: 'supervisorPerformance',
  supervisorPerformanceV2: 'supervisorPerformanceV2',
  SupervisorPerformanceDays: 'SupervisorPerformanceDays',
  getAreTarget: 'getAreTarget',
  getSetTargetList: 'getSetTargetList',
  employeeDetail: 'employeeDetail',
  getPerformanceDetails: 'getPerformanceDetails',
  getSwitchAreDetails: 'getSwitchAreDetails',
  getAreHistoricalPerformanceMonthRange:
    'getAreHistoricalPerformanceMonthRange',
  getAreHistoricalPerformance: 'getAreHistoricalPerformance',
  AgentPerformanceDetails: 'AgentPerformanceThisMonth',
  getAgentHistoricalPerformance: 'getAgentHistoricalPerformance',
  getPerformanceAgentMatrix: 'getPerformanceAgentMatrix',
  agentProfile: 'agentProfile',
  AgentData: 'AgentData',
  ARELists: 'ARELists',
  AREListBranch: 'AREListBranch',
  ARETargetList: 'ARETargetList',
  AgentMaintainable: 'AgentMaintainable',
  getMaintainARESchedule: 'getMaintainARESchedule',
  getMaintainMaintainAssignment: 'getMaintainMaintainAssignment',
  getMaintainReportDetail: 'getMaintainReportDetail',
  getRecruitActivity: 'getRecruitActivity',
  getRecruitmentList: 'getRecruitmentList',
  getRecruitmentReport: 'getRecruitmentReport',
  getRecruitmentActivityReport: 'getRecruitmentActivityReport',
  getRecruitmentDetail: 'getRecruitmentDetail',
  getMaintainActivityReport: 'getMaintainActivityReport',
  getMaintainActivityReportV2: 'getMaintainActivityReportV2',
  getGeneral: 'getGeneral',
  getSearch: 'getSearch',
  getSearchCity: 'getSearchCity',
  getRecruitWeeklyTarget: 'getRecruitWeeklyTarget',
  getRecruitAssignmentList: 'getRecruitAssignmentList',
  getRecruitAll: 'getRecruitAll',
  getJoinVisitReport: 'getJoinVisitReport',
  getJoinVisitAreList: 'getJoinVisitAreList',
  getJoinVisitQuestionList: 'getJoinVisitQuestionList',
  getJoinVisitSummary: 'getJoinVisitSummary',
  getLeadsTrackerList: 'getLeadsTrackerList',
  getLeadsTrackerDetails: 'getLeadsTrackerDetails',
  getOneOnOneAREList: 'getOneOnOneAREList',
  getOneOnOneAREListV2: 'getOneOnOneAREListV2',
  getAverageMaintainRating: 'getAverageMaintainRating',
  getAggregatedMaintainFeedback: 'getAggregatedMaintainFeedback',
  getPreviousActionPlan: 'getPreviousActionPlan',
  getARERecruitPerformace: 'getARERecruitPerformace',
  getARERecruitPerformaceV2: 'getARERecruitPerformaceV2',
  getRecruitPerformanceArea: 'getRecruitPerformanceArea',
  BMList: 'BMList',
  SPVList: 'SPVList',
  Branch: 'Branch',
  BranchRoutine: 'BranchRoutine',
  AgentList: 'AgentList',
  GroupMeetingReport: 'GroupMeetingReport',
  GroupMeetingDetail: 'GroupMeetingDetail',
  IncentiveType: 'IncentiveType',
  IncentiveReportAre: 'IncentiveReportAre',
  IncentiveReportSpv: 'IncentiveReportSpv',
  IncentiveProgram: 'IncentiveProgram',
  MediaBrochures: 'MediaBrochures',
  GetOneOnOneSpvAreReportCount: 'GetOneOnOneSpvAreReportCount',
  getAgentMonthlyPerformanceV2: 'getAgentMonthlyPerformanceV2',
  getAgentHistoricalPerformanceV2: 'getAgentHistoricalPerformanceV2',
  getAgentPerformanceHistoricalAverageV2:
    'getAgentPerformanceHistoricalAverage',
  getAreHistoricalPerformanceMonthRangeV2:
    'getAreHistoricalPerformanceMonthRangeV2',
  arePerformanceV2: 'arePerformanceV2',
  MaintainAssignmentAREList: 'MaintainAssignmentAREList',
  BranchPerformance: 'branchPerformance',
  UserMarketingId: 'UserMarketingId',
  AreaPerformance: 'AreaPerformance',
  AreaPerformanceDays: 'AreaPerformanceDays',
  JoinVisitFeedbackSummary: 'JoinVisitFeedbackSummary',
  RegionList: 'RegionList',
  AreaList: 'AreaList',
  Banks: 'Banks',
  Occupations: 'Occupations',
  AgentListBlacklist: 'AgentListBlacklist',
  AgentDetailBlacklist: 'AgentDetailBlacklist',
  BlacklistHistory: 'BlacklistHistory',
  agentDocumentUnsigned: 'agentDocumentUnsigned',
  AgentUnsignedList: 'AgentUnsignedList',
  ActivityReportSummary: 'ActivityReportSummary',
  MaintainNonRegistAssignmentAREList: 'MaintainNonRegistAssignmentAREList',
  getMaintainMaintainNonRegistAssignment:
    'getMaintainMaintainNonRegistAssignment',
  getMaintainNonRegistARESchedule: 'getMaintainNonRegistARESchedule',
  settingManagement: 'settingManagement',
  settingManagementLog: 'settingManagementLog',
};

export default queryKeys;
